/**
 * Formats any positive or negative string/number value into US Dollar as a string
 * @param {string | number} value - string or number to convert to currency
 */
const formatCurrency = (value) => {
    /**
     *These extra calculations were done because when the value was negative
     *  the NumberFormat function was not working as expected in IE
     */
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) {
        throw new Error("passed value can't be converted to a number");
    }
    const prefix = numberValue < 0 ? '-' : '';
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    const formattedNumber = formatter.format(Math.abs(numberValue));
    return `${prefix}${formattedNumber}`;
};
export default formatCurrency;
